import $ from 'jquery'

$(document).on(
  'change',
  '[data-behaviour="ledger-copier-period-selector"] select',
  () => {
    const $wrappper = $(document).find(
      '[data-behaviour="ledger-copier-period-selector"]'
    )

    const data = $wrappper.find('form').serialize()
    const firmId = $('#current_firm_id').val()
    const ledgerId = $wrappper.data('ledger_id')
    const companyId = $('#current_company_id').val()

    const url = Silverfin.Routes.new_ledger_ledger_copier_path({
      firm_id: firmId,
      company_id: companyId,
      ledger_id: ledgerId,
    })

    $.ajax({
      type: 'GET',
      url: url,
      data: data,
      dataType: 'script',
      beforeSend: () => Silverfin.Spinner.start(),
      complete: () => {
        Silverfin.Spinner.success()
        const submit = document.querySelector("[type='submit']")
        submit.classList.remove('sf-disabled')
        submit.removeAttribute('disabled')
        resetTemplateSelectors()
      },
    })
  }
)

const accountsSelectors = "[data-behaviour~='ledger-copier-account-selector']"
const reconciliationsSelectors =
  "[data-behaviour~='ledger-copier-reconciliation-selector']"

const resetTemplateSelectors = () => {
  $(accountsSelectors).each(function (_, item) {
    const target = $(item).data('target')
    const $accounts = $(document).find(`.accounts-${target}`)
    const $checkboxes = $accounts.find('input[type="checkbox"]')
    const allChecked =
      $checkboxes.length !== 0 &&
      $checkboxes.length ===
        $accounts.find('input[type=checkbox]:checked').length
    $(item).prop('checked', allChecked)
  })

  $(reconciliationsSelectors).each(function (_, item) {
    const $input = $(item).find('input[data-workflow-id]')
    const workflowId = $input.data('workflow-id')
    const $reconTextsList = $(
      `[data-behaviour~='ledger-copier-workflow-list'][data-workflow-id~='${workflowId}']`
    )

    const $checkboxes = $reconTextsList.find('input[type="checkbox"]')
    const allChecked =
      $checkboxes.length !== 0 &&
      $checkboxes.length ===
        $reconTextsList.find('input[type="checkbox"]:checked').length
    $(item).find('input[type="checkbox"]').prop('checked', allChecked)
  })
}

$(document).on('change', accountsSelectors, function () {
  const target = $(this).data('target')
  const checked = $(this).prop('checked')

  $(document)
    .find(`.accounts-${target} input[type=checkbox]`)
    .prop('checked', checked)
  updateCount($(this))
})

$(document).on('change', '#ledger_copier_general_period_properties', () => {
  updateConfirm()
})

// We may have few elements with the same value and name in DOM, we
// want to be able to check/uncheck them all together.
const setCheckedOnSameElements = ($el, isChecked) => {
  $(`[data-behaviour~='ledger-copier-reconciliation-texts-list']`)
    .find(`input[name='${$el.attr('name')}'][value='${$el.attr('value')}']`)
    .prop('checked', isChecked)
}

const updateConfirm = () => {
  const existingData = []
  document
    .querySelectorAll('[data-existing-data]:checked')
    .forEach((input) => existingData.push(input.dataset.existingData))
  const submit = document.querySelector("[type='submit']")
  submit.onclick = (e) => {
    if (existingData.length === 0 || submit.dataset.confirmed === '1') {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    let existingDataWarning = existingData.slice(0, 3).join(', ')
    if (existingData.length > 2) {
      existingDataWarning += I18n.t('shared.used_x_times_more', {
        count: existingData.length - 3,
      })
    }
    window.sfConfirm({
      question: I18n.t(
        'ledger_import.prepare_period.js.override_data_question',
        { period: submit.dataset.period }
      ),
      message: I18n.t('ledger_import.prepare_period.js.override_data_message', {
        existing: existingDataWarning,
      }),
      confirmLabel: I18n.t(
        'ledger_import.prepare_period.js.override_data_confirm',
        { period: submit.dataset.period }
      ),
      onConfirm: () => {
        submit.dataset.confirmed = '1'
        submit.click()
      },
    })
  }
}

const updateCount = ($checkboxWrapper) => {
  const $header = $(`#${$checkboxWrapper.data('header')}`)
  const checkboxes = $header
    .closest('.card')
    .find(`.card-body input[type=checkbox]`)
  updateConfirm()
  updateCounterAttributes(
    $header.find(`div.counter`),
    checkboxes.filter(':checked').length,
    checkboxes.length
  )
}

const updateCounterAttributes = ($counter, checked, total) => {
  let counterClasses = ''
  if (checked !== 0) {
    if (checked === total) counterClasses = 'sf-label-primary sf-label-active'
    else if (checked < total) counterClasses = 'sf-label-primary'
  }
  $counter
    .removeClass('sf-label-primary sf-label-active')
    .addClass(counterClasses)
    .text(`${checked}/${total}`)
}

$(document).on('click', reconciliationsSelectors, function (e) {
  // "Select all" for reconciliation texts needs different
  // implementation than accounts because it has to multi-select the
  // same items between different workflows. That's why we prevent
  // event propagation, so we can handle inputs on our own.
  //
  // Setting data-behaviour on wrapper is a hack for native HTML
  // behaviour. The problem is that all labels and inputs share one
  // ID, so if we click any input/label it will always target the
  // first element. That's why we listen on wrapper click and look for
  // input in this wrapper.
  e.preventDefault()

  const $input = $(this).find('input[data-workflow-id]')
  const workflowId = $input.data('workflow-id')
  const checked = $input.prop('checked')

  const $reconTextsList = $(
    `[data-behaviour~='ledger-copier-workflow-list'][data-workflow-id~='${workflowId}']`
  )

  $reconTextsList.find('input[type=checkbox]').each((_index, el) => {
    setCheckedOnSameElements($(el), !checked)
  })

  $input.prop('checked', !checked)
  updateCount($(this))
})

$(document).on(
  'click',
  "[data-behaviour~='ledger-copier-reconciliation-single']",
  function (e) {
    // We prevent event propagation in this case because we handle
    // checking items between all workflows, not just the clicked one.
    e.preventDefault()

    const $input = $(this).find('input')
    const checked = $input.prop('checked')

    setCheckedOnSameElements($input, !checked)
    updateCount($(this))
  }
)

onDomLoad(function ($dom) {
  $dom.on(
    'change',
    `[data-behaviour~='ledger-copier-accounts-list'] .card-body input[type=checkbox]`,
    function () {
      updateCount($(this))
    }
  )
})
